import { useApolloClient } from "@apollo/client";
import { ModalOpenButton, useScreenWidth } from "@msys/ui";
import { Button } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useNavigate } from "react-router-dom";
import {
  dataURLtoFile,
  uploadFileToUploadCare,
} from "../../attachments/helpers.js";
import { useAcceptQuoteMutation } from "../Quotes.generated.js";
import { MarkQuoteAsAcceptedModal } from "../modals/MarkQuoteAsAcceptedModal.js";

interface Props {
  docId: string;
  projectId: string;
}

export const MarkQuoteAsAcceptedButton = ({ docId, projectId }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslate(["QuoteEdit", "Global"]);
  const client = useApolloClient();
  const { isMaxPhone } = useScreenWidth();

  const [acceptQuote] = useAcceptQuoteMutation({ client });

  return (
    <ModalOpenButton
      Modal={MarkQuoteAsAcceptedModal}
      modalProps={{
        projectId: projectId,
        docId: docId,
        handleComplete: async ({ place, date, signature }) => {
          const attachment = await uploadFileToUploadCare(
            dataURLtoFile(signature, "signature"),
            false
          );

          await acceptQuote({
            variables: {
              input: {
                projectId,
                docId,
                signature: {
                  place: place,
                  date: date.format("YYYY-MM-DD"),
                  signature: {
                    url: attachment.url,
                    title: attachment.title,
                    mimeType: attachment.mimeType,
                  },
                },
              },
            },
          });

          navigate(`/projects/${projectId}/tasks`);
        },
      }}
    >
      <Button color="primary" variant="contained">
        {isMaxPhone
          ? t("Accept", { ns: "Global" })
          : t("Mark quote as accepted", { ns: "QuoteEdit" })}
      </Button>
    </ModalOpenButton>
  );
};
